import {
  startToolOperation,
  type ToolAnalyticsContext,
  type ToolOperation,
} from '@saas-pages/shared/public/runtime'
import type { ShiftPreset } from './shiftCalendar'

const BASE_CONTEXT = {
  app: 'dateify',
  domain: 'dateify.ru',
  route: '/grafik-smen',
  utility: 'shift-calendar',
  processingMode: 'local',
} satisfies ToolAnalyticsContext

export function startShiftCalendarOperation(preset: ShiftPreset): ToolOperation {
  return startToolOperation({ ...BASE_CONTEXT, preset })
}
